/**
 * Toggle header Subscribe vs Cart button based on cart.item_count.
 * Mobile (<=767px): always show cart icon only; hide Subscribe.
 */
(function () {
  const actions = document.querySelector("[data-header-cart-actions]");
  if (!actions) return;

  const subscribeBtn = actions.querySelector(".btn-proudyct-subscribe");
  const cartBtn = actions.querySelector(".wt-cart__trigger");
  const mobileQuery = window.matchMedia("(max-width: 767px)");

  let lastItemCount = parseInt(actions.dataset.cartItemCount || "0", 10);

  function isMobileHeader() {
    return mobileQuery.matches;
  }

  function applyToggle(itemCount) {
    const count = Number(itemCount) || 0;
    const hasItems = count > 0;
    const mobile = isMobileHeader();

    lastItemCount = count;
    actions.dataset.cartItemCount = String(count);

    if (mobile) {
      if (subscribeBtn) subscribeBtn.hidden = true;
      if (cartBtn) cartBtn.hidden = false;
      return;
    }

    if (subscribeBtn) subscribeBtn.hidden = hasItems;
    if (cartBtn) cartBtn.hidden = !hasItems;
  }

  function fetchCartItemCount() {
    const root = window.Shopify?.routes?.root || "/";
    return fetch(`${root}cart.js`)
      .then((response) => response.json())
      .then((cart) => cart.item_count);
  }

  function resolveItemCount(event) {
    const fromEvent = event?.cartData?.item_count;
    if (fromEvent != null) {
      return Promise.resolve(fromEvent);
    }
    return fetchCartItemCount();
  }

  function onCartUpdate(event) {
    resolveItemCount(event).then(applyToggle).catch(() => {});
  }

  applyToggle(lastItemCount);

  if (typeof mobileQuery.addEventListener === "function") {
    mobileQuery.addEventListener("change", () => applyToggle(lastItemCount));
  } else if (typeof mobileQuery.addListener === "function") {
    mobileQuery.addListener(() => applyToggle(lastItemCount));
  }

  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
  }
})();
